<app-header></app-header>

<main class="main-content">
  <!-- Section de désabonnement -->
  <section class="unsubscribe-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="unsubscribe-card">
            <div class="unsubscribe-header">
              <h1 class="unsubscribe-title">Gérer Mon abonnement pour Conversion de Fichier PDF</h1>
              <p class="unsubscribe-intro">
                <strong>Votre satisfaction est au cœur de nos préoccupations !</strong>
              </p>
              <p class="unsubscribe-description">
                Gérer efficacement votre abonnement en quelques clics :
              </p>
            </div>

            <div class="unsubscribe-form">
              <h2 class="form-title">Résilier mon abonnement en ligne :</h2>
              
              <form [formGroup]="unsubscribeForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                  <label for="email" class="form-label">Entrez votre e-mail</label>
                  <input 
                    type="email" 
                    id="email" 
                    class="form-control" 
                    formControlName="email"
                    placeholder="votre@email.com"
                    [class.is-invalid]="unsubscribeForm.get('email')?.invalid && unsubscribeForm.get('email')?.touched">
                  <div *ngIf="unsubscribeForm.get('email')?.invalid && unsubscribeForm.get('email')?.touched" 
                       class="invalid-feedback">
                    Veuillez entrer une adresse email valide
                  </div>
                </div>

                <div class="form-info">
                  <p class="info-text">
                    Votre demande sera immédiatement prise en compte par nos services. Vous ne serez plus débité et la période d'abonnement ne sera plus renouvelée. Un email de confirmation vous sera envoyé (si vous ne recevez pas de mail de notre part, merci de vérifier le dossier "spam" de votre boite de réception).
                  </p>
                </div>

                <button 
                  type="submit" 
                  class="btn btn-unsubscribe"
                  [disabled]="unsubscribeForm.invalid || isLoading">
                  <span *ngIf="!isLoading">Résilier mon abonnement</span>
                  <span *ngIf="isLoading">
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Traitement en cours...
                  </span>
                </button>
              </form>
            </div>

            <!-- Messages de statut -->
            <div *ngIf="successMessage" class="alert alert-success mt-3">
              <i class="bi bi-check-circle me-2"></i>
              {{ successMessage }}
            </div>

            <div *ngIf="errorMessage" class="alert alert-danger mt-3">
              <i class="bi bi-exclamation-triangle me-2"></i>
              {{ errorMessage }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>
